import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Layout, Form, Button, Select, InputNumber, Spin } from 'antd'
import { graphql } from 'react-apollo'

import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import { genLabel } from '../helpers/item'
import productsQurey from '../graphql/queries/products'

import '../css/form.css'

const { Content } = Layout
const FormItem = Form.Item
const { Option } = Select

class ItemLabel extends Component {
  state = {
    product: null,
    amount: 0,
  }
  preview = (e) => {
    e.preventDefault()
    const genItemIds = ({ product, amount }) => {
      const now = (new Date()).getTime().toString(36).toUpperCase()
      const items = Array(amount).fill(10000).map((num, index) => ({
        productId: product._id,
        name: product.name,
        size: product.size,
        color: product.color,
        sku: product.sku,
        shirtId: product.shirtId,
        itemId: `${now}.${(num + index).toString(36).toUpperCase()}`,
      }))
      return items
    }
    const { product, amount } = this.state
    const fillPage = Math.ceil(amount / 2) * 2
    const items = genItemIds({ product, amount: fillPage })
    const html = genLabel(items)
    const wnd = window.open('about:blank', '')
    wnd.document.write(html)
    wnd.document.close()
  }
  handleInputNumberChange = (value) => {
    this.props.form.setFieldsValue({ amount: value })
    this.setState({ amount: value })
  }
  handleSelectChange = (value) => {
    const { products: { products } } = this.props
    this.props.form.setFieldsValue({ product: value })
    this.setState({ product: products[value] })
  }
  render() {
    const { products: { loading, products } } = this.props
    const { getFieldDecorator } = this.props.form
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
      },
    }
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 4,
        },
      },
    }
    return (
      <Layout>
        <Navbar selected="product:3" />
        <Content style={{ padding: '0 20px' }}>
          <div style={{ background: '#fff', padding: 24, minHeight: 'calc(100vh - 64px - 69px)' }}>
            {!loading ? (
              <Form onSubmit={this.preview}>
                <FormItem
                  {...formItemLayout}
                  label="Product"
                >
                  {getFieldDecorator('product', {
                    rules: [{ required: true, message: 'Please select your product!' }],
                  })(
                    <Select
                      placeholder="Select your product"
                      onChange={this.handleSelectChange}
                      defaultActiveFirstOption
                    >
                      {products.map((product, index) => (
                        <Option key={product._id} value={index}>{product.name} {product.size} {product.color}</Option>
                      ))}
                    </Select>
                  )}
                </FormItem>
                <FormItem
                  {...formItemLayout}
                  label="Amount"
                >
                  {getFieldDecorator('amount', {
                    rules: [{ required: true, message: 'Please input amount!' }],
                  })(
                    <InputNumber min={1} onChange={this.handleInputNumberChange} />
                  )}
                </FormItem>
                <FormItem {...tailFormItemLayout}>
                  <Button type="primary" htmlType="submit">Gen label</Button>
                </FormItem>
              </Form>
            ) : (<div style={{ textAlign: 'center' }}><Spin tip="Loading..." /></div>)}
          </div>
        </Content>
        <Footer />
      </Layout>
    )
  }
}
ItemLabel.propTypes = {
  form: PropTypes.shape(),
  products: PropTypes.shape({
    error: PropTypes.object,
    loading: PropTypes.bool,
    products: PropTypes.array,
  }).isRequired,
}
ItemLabel.defaultProps = {
  form: {},
}

export default graphql(productsQurey, { name: 'products' })(Form.create()(ItemLabel))



// WEBPACK FOOTER //
// ./src/pages/ItemLabel.js